export default __webpack_public_path__ + "static/media/Clandestinus Darkhood.1a2a2923.jpg";